import apiClient from "../config/apiClient";


export const reScheduleAppointment = async (data) => {
    const user = window.localStorage.getItem("token");
    const token = user;
    return await apiClient.patch(`/public/portal?url=front-desk/appointments/re-schedule`, data, {
      headers: {
        Authorization: "Bearer " + token,
      },
    });
  };
  
  // front-desk/appointments/new